module.exports = __webpack_public_path__ + "static/img/23_guangai.dfb65a02.png";